import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//
import { Modals } from 'components/Modals';
import {
  restoreUserStateFromLocalStorage,
  logout,
} from 'store/actions/auth.actions';
import { throttle } from 'utils/throttle';
import {
  TIMEOUT_AUTO_LOGOUT,
  LOCAL_STORAGE_KEYS,
  LOCAL_STORAGE_PREFIX,
} from 'config/constants';
import {
  writeToLocalState,
  getFromLocalState,
  clearLocalState,
} from 'utils/localStorage';

@connect(
  ({ authState }) => ({
    isAuth: authState.isAuth,
  }),
  (dispatch) => ({
    restoreUserStateFromLocalStorage: bindActionCreators(
      restoreUserStateFromLocalStorage,
      dispatch,
    ),
    logout: bindActionCreators(logout, dispatch),
  }),
)
export class App extends React.PureComponent {
  constructor(props) {
    super(props);
    this.props.restoreUserStateFromLocalStorage();
  }

  static propTypes = {
    logout: PropTypes.func,
    children: PropTypes.element.isRequired,
    isAuth: PropTypes.bool,
  };

  componentDidMount() {
    window.addEventListener('storage', this.syncLocalSorage, false);

    const lastDateActivity = getFromLocalState(LOCAL_STORAGE_KEYS.LOGOUT_DATE);
    const today = Date.now() - TIMEOUT_AUTO_LOGOUT * 60000;

    if (lastDateActivity <= today) {
      this.logoutHandle();
    }
  }

  syncLocalSorage = ({ key, oldValue, newValue }) => {
    if (key === `${LOCAL_STORAGE_PREFIX}_${LOCAL_STORAGE_KEYS.USER}`) {
      if (!newValue) {
        return this.logoutHandle();
      }

      this.props.restoreUserStateFromLocalStorage();
    }

    if (key === `${LOCAL_STORAGE_PREFIX}_${LOCAL_STORAGE_KEYS.LOGOUT_TIMER}`) {
      clearTimeout(oldValue);
    }
  };

  resetTimeout = () => {
    if (getFromLocalState(LOCAL_STORAGE_KEYS.LOGOUT_TIMER)) {
      clearTimeout(getFromLocalState(LOCAL_STORAGE_KEYS.LOGOUT_TIMER));
    }

    writeToLocalState(
      LOCAL_STORAGE_KEYS.LOGOUT_TIMER,
      setTimeout(this.logoutHandle, TIMEOUT_AUTO_LOGOUT * 60000),
    );
    writeToLocalState(LOCAL_STORAGE_KEYS.LOGOUT_DATE, Date.now());
  };

  logoutHandle = async () => {
    const { logout } = this.props;

    await logout();
    // eslint-disable-next-line no-unused-expressions
    // process.env.NODE_ENV === 'development' ? logout() : () => {};
    clearLocalState(LOCAL_STORAGE_KEYS.LOGOUT_TIMER);
    clearLocalState(LOCAL_STORAGE_KEYS.LOGOUT_DATE);
  };

  throttleLogout = () => {
    const { isAuth } = this.props;

    if (isAuth) {
      this.resetTimeout();
    }
  };

  render() {
    return (
      <div
        className="flex flex-column"
        style={{ minHeight: '100%', height: '100%' }}
        onMouseMove={throttle(this.throttleLogout, 5000)}
        onWheel={throttle(this.throttleLogout, 5000)}
        onKeyPress={throttle(this.throttleLogout, 5000)}
      >
        <Modals />
        {this.props.children}
      </div>
    );
  }
}
